
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttp } from '../../../../../../core/classes/abstract-http';
import { environment } from '../../../../../../../environments/environment';

@Injectable()
export class CustomerArcadeCodeService extends AbstractHttp {
  constructor(http: HttpClient) {
    const url = `${environment.ENTORNO}${environment.SessionService.URL_BaseServices}${environment.SessionService.ENDPOINT.FindPRPaged}`;
    super(http, url);
  }
}
